import React from 'react';
import { Badge, Typography, LinkListItem } from '../../index';
import './proxy_list.scss';

export const ProxyListItem = ({
    picker,
    currentUser,
    primaryUser,
    disabled,
    isShowAllUsers,
    item,
    pickerCollection,
    typographyType,
    showBadge = true
}) => {
    //console.info(`ProxyListItem picker, pickerCollection, item`, picker, pickerCollection, item);
    return <>
        <LinkListItem
            disabled={disabled}
            item={item}
            typographyProps={{ underline: false }}
        >
            <div className="mybswh-proxy-list-item">
                <span className="mybswh-proxy-list-item__label">
                    {item.text}
                </span>
                <Badge
                    count={pickerCollection ? pickerCollection[picker.countField] : 0}
                    show={pickerCollection && pickerCollection[picker.countField] > 0 ? true : false}
                    disabled={disabled ? disabled : item.disabled}
                    colorStyle="subtle"
                ></Badge>
                {showBadge && <Badge
                    text="Viewing"
                    show={!isShowAllUsers && (item.id === currentUser.externalId) && (currentUser.externalId !== primaryUser.externalId) ? true : false}
                    disabled={disabled ? disabled : item.disabled}
                    colorStyle="subtle"></Badge>}
            </div>
        </LinkListItem>
    </>;
}